import React from "react";
// mui
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useTheme } from "@mui/material";
//import FormHelperText from "@mui/material/FormHelperText";
import { CustomTextFieldProps } from "./types/TextField";
import styles from "./assets/scss/text-field.module.scss";

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  error = false,
  helperText,
  width = "100%",
  iconSrc,
  className,
  innerWidth,
  ...textFieldProps
}) => {
  const { multiline } = textFieldProps;

  const theme = useTheme();
  return (
    <div className={className} style={{ width }}>
      <TextField
        error={error}
        helperText={helperText}
        style={{
          width: innerWidth ? (innerWidth != 0 ? innerWidth : width) : width,
          marginBottom: "10px",
          fontFamily: "'Cairo', sans-serif",
        }}
        InputProps={{
          startAdornment: iconSrc && (
            <InputAdornment position="start">
              <img src={iconSrc} style={{ width: "20px", height: "20px" }} />
            </InputAdornment>
          ),
          style: {
            fontFamily: "'Cairo', sans-serif",
            fontSize: "1rem",
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            // "&.Mui-error": {
            //   borderColor: theme.palette.error.main,
            // },
          },
          "& .MuiOutlinedInput-input": {},
          "& .MuiOutlinedInput-input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 100px transparent inset",
            WebkitTextFillColor: "inherit",
            caretColor: "inherit",
          },
        }}
        className={`${
          multiline ? styles["multiline-field"] : styles["txt-field"]
        }`}
        {...textFieldProps}
      />
      {/* {helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )} */}
    </div>
  );
};

export default CustomTextField;
